const appInfo = {
    title: 'derGEFAHRENSUCHER'
};
export default appInfo;

